import * as CardCrawl from "@ravalmatic/cardcrawl-engine";
import { Button } from "../../../utils/Button";
import { GameVars } from "../../../GameVars";
import { GameConstants } from "../../../GameConstants";
import { MulliganButton } from "./MulliganButton";
import { BoardContainer } from "../BoardContainer";
import { AudioManager } from "../../../AudioManager";
import { EventType } from "../../../Types";
import { BoardScene } from "../BoardScene";

export class GUI extends Phaser.GameObjects.Container {

    public mulliganButton: MulliganButton;
    public menuButton: Button;

    private extraAttackButton: Button;
    private extraAttackLabel: Phaser.GameObjects.Text;

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        const lan = GameVars.gameData.language;
        const text = GameVars.currentScene.cache.json.get("text");

        this.menuButton = new Button(this.scene, 55, 55 * GameVars.scaleY, "texture_atlas_1", "btn_menu", "btn_menu");
        this.menuButton.scaleY = GameVars.scaleY;
        this.menuButton.onDown(this.onClickPauseMenu, this);
        this.menuButton.setInflationTween(1.1);
        this.add(this.menuButton);

        if (GameConstants.HAS_REWARDED_ADS && !GameVars.tutorialMode) {

            if (GameVars.gameData.numPlayedGames < 3 ) {

                this.extraAttackLabel = new Phaser.GameObjects.Text(this.scene, 85, GameConstants.GAME_HEIGHT / 2 + 415 * GameVars.scaleY, text.EXTRA_ATTACK[lan], {fontFamily: "Arial", color: "#ffffff", fontSize: "15px"});
                this.extraAttackLabel.setOrigin(.5);
                this.extraAttackLabel.scaleY = GameVars.scaleY;
                this.add(this.extraAttackLabel);

                if (this.extraAttackLabel.width > 150) {
                    this.extraAttackLabel.setScale(150 / this.extraAttackLabel.width, 150 / this.extraAttackLabel.width * GameVars.scaleY);
                }
            }

            this.extraAttackButton = new Button(this.scene, 85, GameConstants.GAME_HEIGHT / 2 + 465 * GameVars.scaleY, "texture_atlas_1", "btn_special_attack", "btn_special_attack");
            this.extraAttackButton.scaleY = GameVars.scaleY;
            this.extraAttackButton.setInflationTween(1.1);
            this.extraAttackButton.onDown(() => {
                this.extraAttackButton.visible = false;
                this.extraAttackLabel.visible = false;
                GameVars.eventsDispatcher.dispatchEvent(new CardCrawl.Event(EventType.EXTRA_ATTACK, []));
            }, this);
            this.add(this.extraAttackButton);
        }

        this.mulliganButton = new MulliganButton(scene);
        this.mulliganButton.x = 300;
        this.mulliganButton.y = -50;
        BoardContainer.currentInstance.upperTableauContainer.add(this.mulliganButton);

        if (GameConstants.DEVELOPMENT) {

            const previoustateLogButton = new Button(this.scene, 50, GameConstants.GAME_HEIGHT - 120 * GameVars.scaleY, "texture_atlas_1", "btn_hard", "btn_hard");
            previoustateLogButton.setScale(.5, .5 * GameVars.scaleY);
            previoustateLogButton.onDown(() => {
                console.clear();
                GameVars.cardCrawlEngine.log(true);
            }, this);
            this.add(previoustateLogButton);

            const currentStateLogButton = new Button(this.scene, 110, GameConstants.GAME_HEIGHT - 120 * GameVars.scaleY, "texture_atlas_1", "btn_hard", "btn_hard");
            currentStateLogButton.setScale(.5, .5 * GameVars.scaleY);
            currentStateLogButton.onDown(() => {
                console.clear();
                GameVars.cardCrawlEngine.log();
            }, this);
            this.add(currentStateLogButton);
        }
    }

    public update(): void {

        this.mulliganButton.update();

        if (GameConstants.HAS_REWARDED_ADS && !GameVars.tutorialMode && this.extraAttackButton.visible) {
            if (!BoardContainer.currentInstance.cardSelectionBlocked) {
                this.extraAttackButton.setInteractive();
                this.extraAttackButton.alpha = 1;
                if (this.extraAttackLabel) {
                    this.extraAttackLabel.alpha = 1;
                }
            } else {
                this.extraAttackButton.disableInteractive();
                this.extraAttackButton.alpha = .5;
                if (this.extraAttackLabel) {
                    this.extraAttackLabel.alpha = .5;
                }
            }
        }
    }

    public startGame(): void {

        this.mulliganButton.startGame();
    }

    public onGameOver(): void {

        this.scene.tweens.add({
            targets: this,
            alpha: 0,
            duration: 400,
            ease: Phaser.Math.Easing.Cubic.Out,
            delay: GameVars.victory ? BoardScene.DELAY_GAME_OVER : 0,
            onComplete: () => {
                this.visible = false;
            },
            onCompleteScope: this
        });
    }

    public resumeGame(): void {

        this.menuButton.visible = true;
    }

    private onClickPauseMenu(): void {

        this.menuButton.visible = false;

        GameVars.eventsDispatcher.dispatchEvent(new CardCrawl.Event(EventType.GAME_PAUSED, []));

        AudioManager.playSound("btn_click");
    }

    private onClickLog(): void {

        console.clear();
        
        GameVars.cardCrawlEngine.log();

        AudioManager.playSound("btn_click");
    }
}
